import { Component, OnInit, ViewChild } from '@angular/core';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService, CoreService } from 'dspx-core';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { NAV_TAB_NUMBERS, PAGE_NUMBERS, SECTION_CODES, QUESTION_CODES, FILTER_QUESTION_CODES } from 'src/app/constants/app-data.constants';
import { ErrorLogGridFilterRequest } from 'src/app/interfaces/error-log-grid-filter-request.interface';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { ExcelExportService } from '../../services/excel-export.service';
import { ExportToDataTablesRequest } from '../../interfaces/export-to-data-tables-request.interface';

@Component({
  selector: 'app-concessions-application-bulk-upload-error-log-list',
  templateUrl: './concessions-application-bulk-upload-error-log-list.component.html',
  styleUrl: './concessions-application-bulk-upload-error-log-list.component.scss'
})
export class ConcessionsApplicationBulkUploadErrorLogListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private excelExportService: ExcelExportService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.concessionsApplicationBulkUploadErrorLogList,
      () => API_ENDPOINTS.dashboard.getConcessionsApplicationBulkUploadErrorLogs,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
      .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadErrorLogListForm.fileNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadErrorLogListForm.createdTimeFilter, TRANSFORM.STRING_TO_DATE)
        .BuildMapper();
  }

  ngOnInit(): void { }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    const applicationFilterRequest = this.getApplicationFilterRequest();
    this.loadGridData(applicationFilterRequest);
  }

  actionButton_errorLogPlaceholder_datagrid_downloadErrorLog_Clicked($event: any) {
    const entityIds: string[] = [$event.event.data.id];
    const request: ExportToDataTablesRequest = { entityIds };
    this.excelExportService.downloadErrorLogBulkUpload(request);
  }

  private getApplicationFilterRequest(): ErrorLogGridFilterRequest {

    const errorLogFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.concessionsApplicationBulkUploadErrorLogForm.errorLogs,
      PAGE_NUMBERS.concessionsApplicationBulkUploadErrorLogForm.errorLogs,
      SECTION_CODES.concessionsApplicationBulkUploadErrorLogForm.errorLog,
      QUESTION_CODES.concessionsApplicationBulkUploadErrorLogForm.errorLogListFilter
    );

    return this.filterQuestionToFilterModelMapper.Map(errorLogFilterModel);
  }

}
